import styled from "styled-components";

export const JackpotBetWidgetGradientBackgroundText777Box = styled.div`
  background: #0EA79B;
  box-shadow: 0px 2px 8px 0px #19322F80, 0px -1px 10px 0px #8CD1BA inset, 0px 0px 5.6px 0px #19322F80 inset;


  width: fit-content;
  border-radius: 30px;
  padding: 4px 12px;
  align-self: center;
  font-size: 3.2rem;
  font-weight: 700;
  line-height: 38.4px;
  letter-spacing: -0.5px;
  text-align: center;
`;
